import React from "react";
import { styled } from "styled-components";

import { ClosedChatFrame } from "./ClosedChatFrame";
import { textColorForBackground } from "./textColor";
import {
  AnnouncementColors,
  AnnouncementPlacement,
  AnnouncementPosition,
} from "./types";

const Card = styled.button<{ $background: string; $color: string }>(
  ({ $background, $color, theme }) => ({
    width: 240,
    padding: "12px 14px",
    border: 0,
    textAlign: "left",
    background: $background,
    color: $color,
    borderRadius: theme.radii[2],
    boxShadow: theme.shadows.surfaceZ1Light,
    cursor: "pointer",
  }),
);

const Title = styled.span({
  display: "block",
  margin: 0,
  marginBottom: 4,
  fontSize: 14,
  fontWeight: 700,
});

const Message = styled.span({
  display: "block",
  margin: 0,
  fontSize: 14,
});

export interface StatusUpdateProps extends AnnouncementColors {
  statusTitle: string;
  message: string;
  placement: AnnouncementPlacement;
  position?: AnnouncementPosition;
  onClick?: () => void;
  onDismiss?: () => void;
}

export const StatusUpdate: React.FC<StatusUpdateProps> = ({
  statusTitle,
  message,
  placement,
  position = "right",
  primaryColor,
  onClick,
  onDismiss,
}) => {
  return (
    <ClosedChatFrame
      placement={placement}
      position={position}
      onDismiss={onDismiss}
      label="Status update"
    >
      <Card
        type="button"
        $background={primaryColor}
        $color={textColorForBackground(primaryColor)}
        onClick={onClick}
      >
        <Title>{statusTitle}</Title>
        <Message>{message}</Message>
      </Card>
    </ClosedChatFrame>
  );
};
